<header class="drag-bar" cdkDragHandle cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <fa-icon icon="arrows-alt"></fa-icon>
<h1 matDialogTitle><fa-icon icon="paragraph"></fa-icon>
    {{ arlInformation }}</h1>
    <span class="spacer"></span>
    <fa-icon class="close-button" icon="times" size="2x" matDialogClose></fa-icon>
</header>
        <mat-label>Langtext:</mat-label>
        <textarea cdkTextareaAutosize cdkAutosizeMinRows="5" matInput [value]="arlLongInformation"  style="max-height: 70vh"></textarea>

